import React from "react";
import ContentLoader from "../../components/contentLoader";

export default function Contact() {
  return (
    <>
      <div className="contentContainer">
        <ContentLoader docName={"contact"} />
      </div>
    </>
  );
}
